import styles from './ProductListButtonContainer.module.css';
const ProductListButtonContainer = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  return <div className={styles.buttonGroup} data-sentry-component="ProductListButtonContainer" data-sentry-source-file="ProductListButtonContainer.tsx">{children}</div>;
};
export default ProductListButtonContainer;